import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

export default {
	init() {

		var container = document.querySelectorAll('main.aboutPage');

		if( container.length !=0  ) {

			function AboutPhotoswipeGallery() {

				var images = document.querySelectorAll('main.aboutPage .content__gallery .gallery__image');
				var image_index = 0;
				var maximalize = document.querySelectorAll('main.aboutPage .content__gallery .gallery__image .image__maximalize');
				var windowWidth = window.innerWidth;

				// *** INIT *** //

					var pswp; // photoSwipe mask
					var items; // photoSwipe images
					var options = Array(); // photoSwipe options
					var photoSwipe; // photoSwipe object

					function Init(index) {

						items = Array();

						pswp = document.querySelectorAll('.pswp')[0];

						options.index = parseInt(index, 10);
						options.fullscreenEl = false;
						options.shareEl = false;

						var item; 
						var image;
						var image_url;
						var image_dimention;
						var image_width;
						var image_height;

						images.forEach( function( image , index2 ) {

							image_url = image.getAttribute('data-url');
							image_dimention = image.getAttribute('data-size').split('x');
							image_width = image_dimention[0];
							image_height = image_dimention[1];

							item = {

								src: image_url,
			                    w: image_width,
			                    h: image_height

							};

							items.push( item );


						});

						photoSwipe = new PhotoSwipe( pswp, PhotoSwipeUI_Default, items, options);

					}

					Init();

				// *** END INIT *** //

				
				
				// *** OPEN *** //

					maximalize.forEach( function( button, index ) {

						button.addEventListener('click', function(){

							if( windowWidth > 1024 ) {

								// console.log( button.getAttribute('data-index') );
								image_index = button.closest('div.gallery__image').getAttribute('data-index');

								Init( image_index );
								photoSwipe.init();

							}

						});

					});

					images.forEach( function( image, index) {

						image.addEventListener('click', function(){

							if( windowWidth <= 1024 ) {

								image_index = image.getAttribute('data-index');

								Init( image_index );
								photoSwipe.init();
								
							
							}	

						});						 

					});

				// *** OPEN *** ///



				// *** RESIZE *** //

					window.addEventListener('resize', ev => {

						windowWidth = window.innerWidth;

					});

				// *** RESIZE *** //

			}

			AboutPhotoswipeGallery();	

		}

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};